
import Vue from 'vue'
import { Message } from 'element-ui'

const state = {
  basicKnowledgePointList: [], // 知识点
  basicQuestionType: [], // 试题类型
  difficultList: [], // 难度
}

const mutations = {
  SET_BASIC_KNOWLEDGEPOINT_LIST (state, data) {
    state.basicKnowledgePointList = data
  },
  SET_QUESTION_TYPE_LIST (state, data) {
    state.basicQuestionType = data
  },
  SET_DIFFICULT_LIST (state, data) {
    state.difficultList = data
  },
}

const actions = {
  // 获取知识点树
  getBasicKnowledgePointList ({commit}, data) {
    commit('SET_BASIC_KNOWLEDGEPOINT_LIST',data)
  },
  // 获取题型列表
  getQuestionTypeList ({commit}, data) {
    commit('SET_QUESTION_TYPE_LIST', data)
  },
  // 获取难度
  getDifficultList ({commit}, data) {
    commit('SET_DIFFICULT_LIST', data)
  },
}

export default {
  state,
  actions,
  mutations,
  namespaced: true // 开启命名空间
}



// WEBPACK FOOTER //
// ./src/vuex/modules/basicDataV3.js